"use client";
import { useState,useTransition } from "react";
import { toast } from "sonner";
import { createItem } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
// Native FormData + server action; replace fields and action for the customer's task.
export function DemoForm() {
 const [pending,start]=useTransition(),[error,setError]=useState("");
 return <form className="space-y-4" onSubmit={event=>{event.preventDefault();const form=event.currentTarget;const data=new FormData(form);start(async()=>{try{const result=await createItem(data);if(result.error){setError(result.error);return;}setError("");form.reset();toast.success("已儲存");}catch{setError("儲存失敗，請再試一次");}});}}>
  <div className="space-y-2"><Label htmlFor="record-title">內容</Label><Input id="record-title" name="title" required maxLength={160} placeholder="新增一筆資料"/></div>
  {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
  <Button type="submit" disabled={pending}>{pending?"儲存中…":"儲存"}</Button>
 </form>;
}
